import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex-shrink-0 flex max-lg:mr-2" }
const _hoisted_2 = {
  key: 0,
  class: "md:relative text-base"
}
const _hoisted_3 = { class: "absolute max-md:right-0 max-md:left-0 -right-6 top-17.5 md:top-2" }

import {ref, watch} from "vue";
import {NavigationUser} from "../../../../../Domain/Navigation/NavigationUser";
import {useClickOutside} from "../../../Helper/clickOutside";
import {useNavigationStore} from "../navigationStore";
import {useNavigationService} from "../vue";
import NavigationControlItem from "./NavigationControlItem.vue";
import NotificationBox from "./NotificationBox.vue";

interface Props {
  user: NavigationUser;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationControl',
  props: {
    user: {}
  },
  emits: ['markAll', 'loadMore'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const store = useNavigationStore();
const service = useNavigationService();
const notificationsOpen = ref<boolean>(false);

function toggleNotifications(): void {
  notificationsOpen.value = !notificationsOpen.value;
}

function showMessages(): void {
  service.action('messages');
}

function markAll(): void {
  emit('markAll');
}

function loadMore(): void {
  emit('loadMore');
}

function closeNotifications(): void {
  notificationsOpen.value = false;
}

const clickOutside = useClickOutside(false);

watch(notificationsOpen, (newValue: boolean): void => {
  if (newValue) {
    clickOutside.addClickListener(closeNotifications);
  } else {
    clickOutside.removeAll();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(NavigationControlItem, {
        icon: "navigationNotification",
        number: props.user.notificationsCount,
        onAction: toggleNotifications
      }, null, 8 /* PROPS */, ["number"]),
      _createVNode(NavigationControlItem, {
        icon: "navigationMessages",
        number: props.user.messagesCount,
        onAction: showMessages
      }, null, 8 /* PROPS */, ["number"])
    ]),
    (notificationsOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(NotificationBox, {
              notifications: props.user.notifications,
              class: "md:w-132",
              onMarkAll: markAll,
              onLoadMore: loadMore
            }, null, 8 /* PROPS */, ["notifications"])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})